import * as React from 'react';

import {Button} from 'shells/button/button';
import {ErrorMessage} from 'shells/form/error-message';
import {LoadingPage} from 'shells/loading-page/loading-page';
import {FooterBar} from 'shells/modal/footer-bar';
import {SingleSelectCards} from 'shells/single-select-cards/single-select-cards';
import {MarketingHeader} from 'shells/typography/marketing-header';
import {ModalBody} from 'shells/typography/modal-body';

import type {
    EditionFragment as DripEdition,
    SmsDripEditionFragment as SmsDripEdition,
} from 'nutshell-graphql-types';

import {EditionPreview} from './edition-preview';
import {editionHasAllRequiredFields} from './helpers';

import styles from './review-messages.module.css';

type Props = {
    onClickPrimary: () => void;
    onClickSecondary: () => void;
    isLoading: boolean;
    editions: DripEdition[] | SmsDripEdition[];
    streetAddress?: string | null | undefined;
    canAccessSetup: boolean;
};

export function ReviewMessages(props: Props) {
    const [selectedEdition, setSelectedEdition] = React.useState<
        DripEdition | SmsDripEdition | null | undefined
    >(props.editions ? props.editions[0] : undefined);

    const isMissingStreetAddress =
        // @ts-expect-error
        !props.streetAddress && props.editions[0].__typename === 'Edition';

    let hasErrors = false;
    const dripEditionsList = [];
    for (const edition of props.editions) {
        let subtitle = 'This message has all required items';
        if (!editionHasAllRequiredFields(edition) || isMissingStreetAddress) {
            hasErrors = true;
            // @ts-expect-error
            subtitle = <ErrorMessage>This message is missing required items</ErrorMessage>;
        }

        dripEditionsList.push({
            id: edition.id,
            title: edition.name,
            subtitle,
        });
    }

    const hasMessageErrors = hasErrors || isMissingStreetAddress;

    return (
        <>
            <div className={styles['review-messages-container']}>
                <MarketingHeader>Prepare your messages to send</MarketingHeader>
                <div className={styles['left-container']}>
                    <ModalBody>Review your messages before activating</ModalBody>
                    <div className={styles['message-list']}>
                        <SingleSelectCards
                            cards={dripEditionsList}
                            selectedId={selectedEdition ? selectedEdition.id : ''}
                            onSelect={(selectedId) => {
                                setSelectedEdition(
                                    props.editions.find((edition) => {
                                        return edition.id === selectedId;
                                    })
                                );
                            }}
                        />
                    </div>
                </div>
                <div className={styles['right-container']}>
                    {selectedEdition && !props.isLoading ? (
                        <EditionPreview
                            selectedEdition={selectedEdition}
                            streetAddress={props.streetAddress}
                            canAccessSetup={props.canAccessSetup}
                        />
                    ) : (
                        <LoadingPage />
                    )}
                </div>
            </div>
            <FooterBar
                left={
                    <Button variant='text' size='big' onClick={props.onClickSecondary}>
                        Cancel
                    </Button>
                }
                right={
                    <Button
                        variant='primary'
                        size='big'
                        onClick={props.onClickPrimary}
                        disabled={hasMessageErrors}
                    >
                        Next
                    </Button>
                }
            />
        </>
    );
}
